import { useLocation } from "react-router-dom";

const siteUrl = "https://www.timscdrmumbai.in";

const routeMetadata = {
  "/": {
    title: "Best MCA College in Mumbai | TIMSCDR Kandivali",
    description: "Thakur Institute of Management Studies, Career Development & Research (TIMSCDR) is a leading MCA college in Mumbai with industry-focused Computer Applications education.",
  },
  "/vision-mission": {
    title: "Vision & Mission | Leading MCA College in India - TIMSCDR",
    description: "Explore the vision and mission of TIMSCDR, a top MCA college in Mumbai, focused on software education, emerging technologies, leadership, research and professional development.",
  },
  "/peo-Page": {
    title: "MCA Program Educational Objectives (PEOs) | TIMSCDR Mumbai",
    description: "Discover the MCA PEOs and POs at TIMSCDR, Mumbai, focused on software development, emerging technologies, research, leadership and professional development.",
  },
  "/quality-policy": {
    title: "Organization Policy | Trusted MCA College in Mumbai - TIMSCDR",
    description: "Explore the education policies at TIMSCDR, a top MCA college in Mumbai, supporting quality education, academic excellence, student development and professional learning.",
  },
  "/chairmans-message": {
    title: "Chairman's Message | TIMSCDR - MCA College in Mumbai",
    description: "Read the Chairman's Message at TIMSCDR, one of the leading MCA colleges in Mumbai, committed to academic excellence, innovation, quality education, and student success.",
  },
  "/ceos-message": {
    title: "CEO's Message | Top MCA College in Mumbai - TIMSCDR",
    description: "Read the CEO's message from Thakur Institute of Management Studies, Career Development & Research and learn about our vision for quality education and innovation.",
  },
  "/directors-message": {
    title: "Director Message | MCA College in Mumbai - Timscdr",
    description: "Read the Director's Message from Thakur Institute of Management Studies, Career Development & Research, sharing our vision for academic excellence and innovation.",
  },
  "/governing-council": {
    title: "Governing Council | Top MCA College in Mumbai - TIMSCDR",
    description: "Meet the Governing Council at TIMSCDR, a top MCA college in Mumbai, guiding academic excellence, institutional governance, quality education, and strategic growth.",
  },
  "/advisory-board": {
    title: "Advisory Board | Best MCA College in Mumbai | TIMSCDR",
    description: "Meet the Advisory Board at TIMSCDR, a top MCA college in Mumbai, fostering innovation, industry collaboration, academic excellence, and student success.",
  },
  "/academic-council": {
    title: "Academic Council | Top MCA College in Mumbai - TIMSCDR",
    description: "Meet the Academic Council at TIMSCDR, a top MCA college in Mumbai, guiding academic excellence, curriculum development, quality education, and institutional growth.",
  },
  "/college-development-committee": {
    title: "College Development Committee | TIMSCDR Mumbai",
    description: "Explore the College Development Committee at TIMSCDR, dedicated to institutional growth, academic excellence, quality education, and strategic development.",
  },
  "/cells-and-committees": {
    title: "Cells & Committees | TIMSCDR Kandivali, Mumbai",
    description: "Explore the Cells & Committees at TIMSCDR Kandivali, fostering student welfare, academic quality, research, inclusivity, ethical practices, and institutional development.",
  },
  "/organogram": {
    title: "Institute Organogram | TIMSCDR Kandivali, Mumbai",
    description: "Explore the Organogram of Thakur Institute of Management Studies, Career Development & Research, outlining its organizational structure and governance.",
  },
  "/policies": {
    title: "Academic & Administrative Policies | TIMSCDR Mumbai",
    description: "Explore the policies of Thakur Institute of Management Studies, Career Development & Research, covering academic, administrative, and institutional guidelines.",
  },
  "/program/mca-program": {
    title: "Master of Computer Applications (MCA) | TIMSCDR Kandivali, Mumbai",
    description: "Join TIMSCDR Kandivali, a leading MCA college in Mumbai, and pursue a Master of Computer Applications with industry-focused learning and excellent placement support.",
  },
  "/program-mca-working-professionals": {
    title: "MCA for Working Professionals | TIMSCDR Kandivali, Mumbai",
    description: "Explore the Top MCA Program for Working Professionals in Mumbai at Thakur Institute of Management Studies, Career Development & Research with flexible hybrid learning.",
  },
  "/integrated-mca": {
    title: "Integrated MCA | TIMSCDR Kandivali, Mumbai",
    description: "Join the 5-Year Integrated MCA programme at TIMSCDR Kandivali, one of the leading Integrated MCA colleges in Mumbai, and build a successful IT career.",
  },
  "/ph-d-admission": {
    title: "Ph.D. in Computer Application Admissions | TIMSCDR Mumbai",
    description: "Join TIMSCDR, one of the best colleges in Mumbai, for a Ph.D. in Computer Application with expert faculty, research opportunities, and academic excellence.",
  },
  "/master-of-computer-applications-mca": {
    title: "MCA Admission | Best MCA College in Mumbai | TIMSCDR",
    description: "Apply to one of the Top MCA Colleges in Mumbai at Thakur Institute of Management Studies, Career Development & Research and build a successful IT career.",
  },
  "/mca-working-professional": {
    title: "MCA Admission for Working Professionals | TIMSCDR",
    description: "Apply for MCA Admission for Working Professionals at Thakur Institute of Management Studies, Career Development & Research with flexible hybrid learning.",
  },
  "/imca": {
    title: "MCA Integrated Admissions in Mumbai | Apply at TIMSCDR",
    description: "Apply for Integrated MCA Admission at Thakur Institute of Management Studies, Career Development & Research and build a strong foundation for a successful IT career.",
  },
  "/phd-admission": {
    title: "Ph.D. in Computer Applications | TIMSCDR mumbai",
    description: "Apply for the Ph.D. Program at Thakur Institute of Management Studies, Career Development & Research and pursue advanced research in Computer Applications.",
  },
  "/seat-distribution": {
    title: "Seat Distribution | MCA Admissions | TIMSCDR Mumbai",
    description: "Explore the seat distribution at Thakur Institute of Management Studies, Career Development & Research for MCA, Integrated MCA and MCA for Working Professionals.",
  },
  "/aicte-approval-2": {
    title: "AICTE Approved Institute | Thakur TIMSCDR Mumbai",
    description: "View the AICTE Approval documents of Thakur Institute of Management Studies, Career Development & Research for approved MCA programs and academic years.",
  },
  "/admission-notification": {
    title: "Latest MCA Admission Notifications | TIMSCDR Mumbai",
    description: "View the latest admission notifications from Thakur Institute of Management Studies, Career Development & Research for MCA, Integrated MCA and Ph.D. programs.",
  },
  "/student-handbook": {
    title: "Student Handbook | TIMSCDR Mumbai MCA Institute",
    description: "Access the TIMSCDR Student Handbook for academic regulations, code of conduct, student support services, placements, campus policies, and MCA guidelines.",
  },
  "/code-of-conduct": {
    title: "Student Code of Conduct at TIMSCDR Mumbai | MCA",
    description: "Read the TIMSCDR Student Code of Conduct covering academic integrity, attendance, discipline, ethics, campus rules, and student responsibilities for MCA programmes.",
  },
  "/student-mentoring-program": {
    title: "Student Mentoring Program | TIMSCDR Mumbai MCA Institute",
    description: "Discover the TIMSCDR Student Mentoring Program, offering academic guidance, personal support, skill development, and career mentoring to help MCA students succeed.",
  },
  "/anti-ragging": {
    title: "Anti-Ragging Policy | TIMSCDR Mumbai MCA Institute",
    description: "Learn about the TIMSCDR Anti-Ragging Policy, ensuring a safe, respectful, and inclusive campus with strict anti-ragging measures, awareness, and student support.",
  },
  "/canditate-aganist-cap": {
    title: "Candidate Against CAP | TIMSCDR Kandivali, Mumbai",
    description: "Apply for Candidate Against CAP admission at TIMSCDR Mumbai. Explore eligibility, admission process, required documents, seat availability, and MCA admission guidelines.",
  },
  "/fra-fee-structure": {
    title: "FRA Fee Structure | MCA Institute in Mumbai | TIMSCDR",
    description: "View the TIMSCDR FRA-approved MCA fee structure, including tuition fees, development fees, management seat fees, refundable deposits, and admission details.",
  },
  "/integrated-mca-2": {
    title: "Integrated MCA Program | TIMSCDR Mumbai Admissions",
    description: "Explore the Integrated MCA Program at TIMSCDR Mumbai with industry-focused curriculum, expert faculty, practical learning, and excellent career opportunities.",
  },
  "/phd": {
    title: "Ph.D. in Computer Applications in Mumbai | TIMSCDR",
    description: "Explore Ph.D. admission in Computer Applications at TIMSCDR, Mumbai. Discover eligibility, research areas and opportunities for advanced academic research.",
  },
  "/faculty-list-2": {
    title: "Faculty List | Best MCA Institute TIMSCDR Mumbai",
    description: "Explore the TIMSCDR faculty list featuring experienced professors, associate professors, and assistant professors dedicated to quality MCA education and research.",
  },
  "/staff": {
    title: "Faculty at TIMSCDR Mumbai | Experienced MCA Faculty",
    description: "Explore the faculty at TIMSCDR, one of the leading MCA colleges in Mumbai. Meet experienced professors and faculty members in computer applications and technology.",
  },
  "/non-teaching-staff": {
    title: "Non Teaching Staff | Top MCA Colleges in Mumbai | TIMSCDR",
    description: "Meet the non-teaching staff at TIMSCDR Mumbai, providing administrative, technical, and student support services to ensure smooth academic and campus operations.",
  },
  "/teaching-pedagogy": {
    title: "Teaching Pedagogy | Best MCA College in Mumbai | TIMSCDR",
    description: "Explore the teaching pedagogy at TIMSCDR Mumbai, combining innovative learning methods, industry-focused curriculum, practical exposure, and academic excellence.",
  },
  "/student-downloads": {
    title: "Student Downloads | TIMSCDR Mumbai MCA Institute",
    description: "Download important student forms, academic documents, certificates, policies, notices, and essential resources from the TIMSCDR Student Downloads portal.",
  },
  "/infrastructure": {
    title: "Infrastructure | Best MCA College in Mumbai | TIMSCDR",
    description: "Explore TIMSCDR Mumbai's modern infrastructure featuring smart classrooms, advanced computer labs, digital library, seminar halls, hostel, and student facilities.",
  },
  "/drc": {
    title: "Disability Resource Center | TIMSCDR Mumbai Institute",
    description: "Explore the Disability Resource Center at TIMSCDR Mumbai, offering accessible facilities, academic support, inclusive services, and equal opportunities for students.",
  },
  "/about-library": {
    title: "About Library | Top MCA College | TIMSCDR Mumbai",
    description: "Explore the library at TIMSCDR, a top MCA college in Mumbai, offering books, e-books, journals, digital resources, reading facilities, and research support.",
  },
  "/infrastructure-and-facilities": {
    title: "Infrastructure & Facilities | Best MCA College | TIMSCDR Mumbai",
    description: "Explore modern infrastructure and facilities at TIMSCDR, a top MCA college in Mumbai, with smart classrooms, advanced labs, library, Wi-Fi, and student amenities.",
  },
  "/timscdr-library-holding": {
    title: "Library Holdings | Top MCA College in Mumbai | TIMSCDR",
    description: "Explore TIMSCDR Library Holdings at a top MCA college in Mumbai, featuring books, journals, e-books, research resources, and year-wise library collection details.",
  },
  "/library-timing-and-rules": {
    title: "Library Timings & Rules | Best MCA College in mumbai | TIMSCDR",
    description: "Check the library timings and rules at TIMSCDR, a top MCA college in Mumbai. Learn about library hours, borrowing policies, student guidelines, and library services.",
  },
  "/virtual-reading-resource": {
    title: "Virtual Reading Resources | MCA College in Kandivali | TIMSCDR",
    description: "Access virtual reading resources at TIMSCDR, a top MCA college in Mumbai, including e-books, e-journals, digital libraries, research databases, and online learning tools.",
  },
  "/research-cell": {
    title: "Research Cell | Top MCA College in Mumbai | TIMSCDR",
    description: "Explore the Research Cell at TIMSCDR, a top MCA college in Mumbai, promoting innovation, funded projects, publications, industry collaboration, and research excellence.",
  },
  "/institution-innovation-council-iic": {
    title: "Institution Innovation Council | MCA College | TIMSCDR Mumbai",
    description: "Explore the Institution Innovation Council (IIC) at TIMSCDR, a top MCA college in Mumbai, promoting innovation, entrepreneurship, startups, research, and creative learning.",
  },
  "/icaim-2026": {
    title: "ICAIM 2026 | Best MCA College in Mumbai | TIMSCDR",
    description: "TIMSCDR (Thakur Institute of Management Studies, Career Development & Research) is a top MCA college in Mumbai offering quality education, research, and innovation.",
  },
  "/icaim-2025": {
    title: "ICAIM 2025 | Top MCA College in Mumbai | TIMSCDR",
    description: "Explore ICAIM 2025 at TIMSCDR, a top MCA college in Mumbai, featuring AI research, expert talks, paper presentations, hackathons, workshops, and innovation.",
  },
  "/best-mca-college-in-mumbai-for-placements-about-placement": {
    title: "Best MCA College in Mumbai for Placements | TIMSCDR",
    description: "Explore placement opportunities at TIMSCDR, one of the leading MCA colleges in Mumbai. Discover recruiters, career support, industry exposure and placement highlights.",
  },
  "/training-programme": {
    title: "Training Programme for MCA Students in Mumbai | TIMSCDR",
    description: "Explore training programmes at TIMSCDR, Mumbai, including student development, workshops, aptitude training, resume building, interview preparation and more.",
  },
  "/placement-data": {
    title: "MCA Placement Data & Statistics in Mumbai | TIMSCDR",
    description: "Explore MCA placement data and statistics at TIMSCDR, Mumbai. View placement records, internship outcomes and career opportunities across multiple batches.",
  },
  "/training-and-placement-policy": {
    title: "Training & Placement Policy | Top MCA College | TIMSCDR",
    description: "Read the Training & Placement Policy at TIMSCDR, a top MCA college in Mumbai, covering eligibility, placement process, student guidelines, and recruitment rules.",
  },
  "/faculty-development-programme": {
    title: "Faculty Development Programs | Top MCA College | TIMSCDR",
    description: "Explore Faculty Development Programs at TIMSCDR, a top MCA college in Mumbai, enhancing teaching excellence, research, innovation, and industry-oriented learning.",
  },
  "/short-term-training-programme": {
    title: "Short Term Training Programme | MCA College in mumbai | TIMSCDR",
    description: "Explore Short Term Training Programmes at TIMSCDR, a top MCA college in Mumbai, enhancing faculty skills through workshops, research, innovation, and industry-focused learning.",
  },
  "/life/trekking": {
    title: "Trekking & Student Activities in Mumbai | TIMSCDR",
    description: "Explore trekking and student activities at TIMSCDR, Mumbai. Discover outdoor experiences, adventure activities and extracurricular opportunities for MCA students.",
  },
  "/life/health-hygiene": {
    title: "Health & Hygiene Activities for Students in Mumbai | TIMSCDR",
    description: "Explore student health and hygiene programmes at TIMSCDR, Mumbai, including blood donation camps, menstrual hygiene awareness, health talks and wellness activities.",
  },
  "/life/clean-india-campaign": {
    title: "Clean India Campaign | Best MCA College | TIMSCDR Mumbai",
    description: "Explore the Clean India Campaign at TIMSCDR, a top MCA college in Mumbai, promoting cleanliness, environmental awareness, social responsibility, and community service.",
  },
  "/life/socialevents": {
    title: "Social Events & Student Activities in Mumbai | TIMSCDR",
    description: "Explore social events at TIMSCDR, a top MCA college in Mumbai, promoting community service, social responsibility, environmental awareness, and student engagement.",
  },
  "/life/hackathon": {
    title: "Hackathons for MCA Students in Mumbai | TIMSCDR",
    description: "Explore hackathons at TIMSCDR, Mumbai, where MCA students develop innovative solutions through coding, AI, problem-solving, teamwork and industry-focused challenges.",
  },
  "/contact": {
    title: "Top MCA College in Mumbai | Contact TIMSCDR Kandivali",
    description: "Contact TIMSCDR Kandivali, a top MCA college in Mumbai, for MCA admissions, programme details, academic enquiries, campus information, address, phone number and email.",
  },
  "/blogs": {
    title: "MCA Blogs & Latest Updates in Mumbai | TIMSCDR",
    description: "Explore TIMSCDR blogs for the latest insights on MCA, computer applications, technology, education, careers, industry trends and student opportunities in Mumbai.",
  },

  // Alias routes — same SEO as primary
  "/trekking": {
    title: "Trekking & Student Activities in Mumbai | TIMSCDR",
    description: "Explore trekking and student activities at TIMSCDR, Mumbai. Discover outdoor experiences, adventure activities and extracurricular opportunities for MCA students.",
  },
  "/social-events": {
    title: "Social Events & Student Activities in Mumbai | TIMSCDR",
    description: "Explore social events at TIMSCDR, a top MCA college in Mumbai, promoting community service, social responsibility, environmental awareness, and student engagement.",
  },
  "/hackathon": {
    title: "Hackathons for MCA Students in Mumbai | TIMSCDR",
    description: "Explore hackathons at TIMSCDR, Mumbai, where MCA students develop innovative solutions through coding, AI, problem-solving, teamwork and industry-focused challenges.",
  },
  "/health-hygiene": {
    title: "Health & Hygiene Activities for Students in Mumbai | TIMSCDR",
    description: "Explore student health and hygiene programmes at TIMSCDR, Mumbai, including blood donation camps, menstrual hygiene awareness, health talks and wellness activities.",
  },
  "/clean-india-campaign": {
    title: "Clean India Campaign | Best MCA College | TIMSCDR Mumbai",
    description: "Explore the Clean India Campaign at TIMSCDR, a top MCA college in Mumbai, promoting cleanliness, environmental awareness, social responsibility, and community service.",
  },
  "/self-defense": {
    title: "Self Defence Program for Women | TIMSCDR Mumbai",
    description: "Explore the self-defence programme at TIMSCDR Mumbai, empowering women students with safety skills, confidence, and awareness through expert-led training sessions.",
  },
  "/women-entrepreneurs": {
    title: "Women Entrepreneurs Cell | TIMSCDR Mumbai",
    description: "Explore the Women Entrepreneurs Cell at TIMSCDR Mumbai, fostering entrepreneurship, leadership, innovation, and business skills among women MCA students.",
  },
  "/women-health": {
    title: "Women Health Initiatives | TIMSCDR Mumbai",
    description: "Explore women health initiatives at TIMSCDR Mumbai, promoting wellness, hygiene awareness, mental health, and overall well-being among women students.",
  },
  "/unnat-bharat-abhiyan": {
    title: "Unnat Bharat Abhiyan | TIMSCDR Mumbai",
    description: "Explore the Unnat Bharat Abhiyan initiative at TIMSCDR Mumbai, connecting students with rural communities for sustainable development and social impact.",
  },
  "/cultural-day": {
    title: "Cultural Day | Student Life at TIMSCDR Mumbai",
    description: "Celebrate Cultural Day at TIMSCDR Mumbai, where MCA students showcase talent, creativity, and cultural diversity through performances, events, and activities.",
  },
  "/freshers-welcome": {
    title: "Freshers Welcome & Farewell | TIMSCDR Mumbai",
    description: "Experience the Freshers Welcome and Farewell celebrations at TIMSCDR Mumbai, fostering student bonding, memories, and a vibrant campus culture.",
  },
  "/sports-day": {
    title: "Sports Day | Student Activities at TIMSCDR Mumbai",
    description: "Explore Sports Day at TIMSCDR Mumbai, promoting fitness, teamwork, sportsmanship, and healthy competition among MCA students through various sporting events.",
  },
  "/magazine-eminence": {
    title: "Magazine Eminence | TIMSCDR Mumbai",
    description: "Read Eminence, the student magazine of TIMSCDR Mumbai, featuring articles, research, achievements, campus news, and creative contributions from MCA students.",
  },
  "/news-letter": {
    title: "Newsletter | TIMSCDR Mumbai MCA Institute",
    description: "Stay updated with the TIMSCDR Newsletter featuring the latest campus news, academic updates, student achievements, events, and institutional highlights.",
  },

  // Examination
  "/notice": {
    title: "Notice Board | TIMSCDR Mumbai MCA Institute",
    description: "View the latest notices, circulars, and announcements from TIMSCDR Mumbai for MCA students, faculty, and staff regarding academics, exams, and campus events.",
  },
  "/university-schedule": {
    title: "University Exam Schedule | TIMSCDR Mumbai",
    description: "Check the latest university exam schedule and timetable at TIMSCDR Mumbai for MCA, Integrated MCA, and other programmes.",
  },
  "/timetable": {
    title: "Exam Timetable | TIMSCDR Mumbai MCA Institute",
    description: "Access the exam timetable at TIMSCDR Mumbai for MCA and Integrated MCA programmes, including university schedules and internal assessment dates.",
  },
  "/university-gazette": {
    title: "University Gazette & MCA Results | TIMSCDR Mumbai",
    description: "Access the University Gazette and MCA results at TIMSCDR Mumbai, including semester results, marksheets, and academic performance records.",
  },
  "/result-analysis": {
    title: "Result Analysis | Top MCA College in Mumbai | TIMSCDR",
    description: "Explore result analysis at TIMSCDR, a top MCA college in Mumbai, showcasing academic performance, pass percentages, and semester-wise result trends.",
  },
  "/convocation": {
    title: "Convocation Ceremony | TIMSCDR Mumbai MCA Institute",
    description: "Celebrate academic achievements at the TIMSCDR Convocation Ceremony, honouring graduating MCA students with degrees, medals, and recognition.",
  },

  // Facilities
  "/infrastructure-gallery": {
    title: "Infrastructure Gallery | Best MCA College | TIMSCDR Mumbai",
    description: "View the infrastructure gallery of TIMSCDR Mumbai showcasing smart classrooms, computer labs, library, seminar halls, and modern campus facilities.",
  },
  "/library-committee": {
    title: "Library Committee | Top MCA College in Mumbai | TIMSCDR",
    description: "Explore the Library Committee at TIMSCDR, a top MCA college in Mumbai, overseeing library resources, policies, digital access, and student reading facilities.",
  },

  // IQAC
  "/iqac/naac-iiqa": {
    title: "NAAC IIQA | Top MCA College in Mumbai | TIMSCDR",
    description: "Access the NAAC IIQA documents of TIMSCDR, a top MCA college in Mumbai, reflecting our commitment to quality education and institutional excellence.",
  },
  "/iqac/naac-ssr": {
    title: "NAAC SSR | Top MCA College in Mumbai | TIMSCDR",
    description: "Access the NAAC Self Study Report (SSR) of TIMSCDR, a top MCA college in Mumbai, highlighting academic quality, research, and institutional achievements.",
  },
  "/iqac-mom": {
    title: "IQAC Minutes of Meeting | TIMSCDR Mumbai",
    description: "Access the IQAC Minutes of Meeting at TIMSCDR Mumbai, documenting quality initiatives, academic decisions, and institutional improvement strategies.",
  },
  "/NAAC-Certificate": {
    title: "NAAC Certificate | Top MCA College in Mumbai | TIMSCDR",
    description: "View the NAAC Accreditation Certificate of TIMSCDR, a top MCA college in Mumbai, reflecting our commitment to quality education and academic excellence.",
  },
  "/naac-aqar": {
    title: "NAAC AQAR | Top MCA College in Mumbai | TIMSCDR",
    description: "Access the NAAC Annual Quality Assurance Report (AQAR) of TIMSCDR Mumbai, highlighting quality initiatives, academic progress, and institutional development.",
  },

  // R&D
  "/ipr": {
    title: "Intellectual Property Rights (IPR) | TIMSCDR Mumbai",
    description: "Explore IPR initiatives at TIMSCDR Mumbai, promoting innovation, patents, copyrights, and intellectual property awareness among students and faculty.",
  },
  "/international-conferenceicaim-2023": {
    title: "ICAIM 2023 | International Conference | TIMSCDR Mumbai",
    description: "Explore ICAIM 2023 at TIMSCDR Mumbai, an international conference on AI and intelligent machines featuring research papers, expert talks, and innovation.",
  },
  "/icaim-2024": {
    title: "ICAIM 2024 | International Conference | TIMSCDR Mumbai",
    description: "Explore ICAIM 2024 at TIMSCDR Mumbai, featuring cutting-edge research, expert sessions, paper presentations, and innovation in AI and computer applications.",
  },
  "/international-conferenceicaim-2022": {
    title: "ICAIM 2022 | International Conference | TIMSCDR Mumbai",
    description: "Explore ICAIM 2022 at TIMSCDR Mumbai, an international conference on AI and intelligent machines with research presentations and expert discussions.",
  },
  "/icaim-2021": {
    title: "ICAIM 2021 | International Conference | TIMSCDR Mumbai",
    description: "Explore ICAIM 2021 at TIMSCDR Mumbai, featuring research in AI, machine learning, and computer applications through expert talks and paper presentations.",
  },
  "/international-conferenceicaim-2020": {
    title: "ICAIM 2020 | International Conference | TIMSCDR Mumbai",
    description: "Explore ICAIM 2020 at TIMSCDR Mumbai, the inaugural international conference on AI and intelligent machines with research papers and expert sessions.",
  },
  "/iot-excellence": {
    title: "IoT Lab Excellence | TIMSCDR Mumbai",
    description: "Explore the IoT Lab Excellence centre at TIMSCDR Mumbai, providing hands-on learning in Internet of Things, smart systems, and emerging technologies.",
  },
  "/techtonics": {
    title: "TechTonics | Technical Fest | TIMSCDR Mumbai",
    description: "Explore TechTonics, the annual technical festival at TIMSCDR Mumbai, featuring competitions, workshops, hackathons, and innovation challenges for MCA students.",
  },
  "/consultancy": {
    title: "Consultancy Services | TIMSCDR Mumbai",
    description: "Explore consultancy services at TIMSCDR Mumbai, offering industry expertise, technical solutions, and research-based consulting to organisations and businesses.",
  },
  "/national-conference-2025": {
    title: "National Conference 2025 | TIMSCDR Mumbai",
    description: "Explore the National Conference 2025 at TIMSCDR Mumbai, featuring research presentations, expert talks, and academic discussions in computer applications.",
  },

  // Contact
  "/student-grievance-redressal": {
    title: "Student Grievance Redressal | TIMSCDR Mumbai",
    description: "Submit and resolve student grievances at TIMSCDR Mumbai through our transparent and efficient grievance redressal system for a fair campus experience.",
  },
  "/recruitment": {
    title: "Recruitment | Career Opportunities at TIMSCDR Mumbai",
    description: "Explore career and recruitment opportunities at TIMSCDR Mumbai. Join our team of dedicated faculty and staff committed to academic excellence and innovation.",
  },

  // Alumni
  "/alumni-association": {
    title: "Alumni Association | TIMSCDR Mumbai MCA Institute",
    description: "Connect with the TIMSCDR Alumni Association, a network of successful MCA graduates contributing to industry, innovation, and the growth of their alma mater.",
  },
  "/alumni-interaction": {
    title: "Alumni Interaction | TIMSCDR Mumbai MCA Institute",
    description: "Explore alumni interaction programmes at TIMSCDR Mumbai, where successful graduates share industry insights, career guidance, and experiences with current students.",
  },
  "/our-distinguished-alumni": {
    title: "Distinguished Alumni | TIMSCDR Mumbai MCA Institute",
    description: "Meet the distinguished alumni of TIMSCDR Mumbai, successful professionals making an impact across industries, technology, research, and entrepreneurship.",
  },
  "/alumni-testimonials": {
    title: "Alumni Testimonials | TIMSCDR Mumbai MCA Institute",
    description: "Read testimonials from TIMSCDR alumni sharing their experiences, career journeys, and how their MCA education shaped their professional success.",
  },

  // Quick Links
  "/college-grievance-redressal-committee": {
    title: "College Grievance Redressal Committee | TIMSCDR Mumbai",
    description: "Learn about the College Grievance Redressal Committee at TIMSCDR Mumbai, ensuring fair resolution of student, faculty, and staff grievances.",
  },
  "/womens-grievance-redressal-committee": {
    title: "Women's Grievance Redressal Committee | TIMSCDR Mumbai",
    description: "Explore the Women's Grievance Redressal Committee at TIMSCDR Mumbai, ensuring a safe, respectful, and inclusive environment for all women on campus.",
  },
  "/downloads": {
    title: "Downloads | TIMSCDR Mumbai MCA Institute",
    description: "Download important forms, documents, brochures, academic resources, and official publications from TIMSCDR Mumbai's downloads section.",
  },
  "/feedback": {
    title: "Feedback | TIMSCDR Mumbai MCA Institute",
    description: "Share your feedback with TIMSCDR Mumbai to help us improve academic quality, campus facilities, student services, and overall institutional performance.",
  },
  "/mandatory-disclosure": {
    title: "Mandatory Disclosure | TIMSCDR Mumbai MCA Institute",
    description: "Access the mandatory disclosure documents of TIMSCDR Mumbai as required by AICTE, covering institutional details, faculty, infrastructure, and academic information.",
  },
  "/RTI": {
    title: "Right to Information (RTI) | TIMSCDR Mumbai",
    description: "Access RTI information at TIMSCDR Mumbai as per the Right to Information Act, providing transparency in institutional operations and governance.",
  },
  "/content-policy": {
    title: "Content Policy | TIMSCDR Mumbai MCA Institute",
    description: "Read the content policy of TIMSCDR Mumbai governing the use, publication, and management of digital content on the institute's website and platforms.",
  },
  "/disclaimer": {
    title: "Disclaimer | TIMSCDR Mumbai MCA Institute",
    description: "Read the disclaimer of TIMSCDR Mumbai regarding the accuracy, completeness, and use of information published on the official institute website.",
  },

  // Life @ - remaining
  "/life/industrial-visit": {
    title: "Industrial Visits for MCA Students | TIMSCDR Mumbai",
    description: "Explore industrial visits at TIMSCDR Mumbai, giving MCA students hands-on exposure to industry operations, technology, and real-world professional environments.",
  },
  "/life/e-cell-ayan": {
    title: "E-Cell Ayan | Entrepreneurship Cell | TIMSCDR Mumbai",
    description: "Explore E-Cell Ayan at TIMSCDR Mumbai, fostering entrepreneurship, startup culture, innovation, and business development among MCA students.",
  },
  "/life/synapse": {
    title: "Synapse | Student Activity | TIMSCDR Mumbai",
    description: "Explore Synapse, a student activity at TIMSCDR Mumbai, promoting technical skills, innovation, collaboration, and extracurricular development among MCA students.",
  },
  "/life/vista": {
    title: "Vista | Student Activity | TIMSCDR Mumbai",
    description: "Explore Vista at TIMSCDR Mumbai, a student-driven initiative promoting creativity, leadership, technical skills, and holistic development among MCA students.",
  },
  "/life/dlle": {
    title: "DLLE | Department of Lifelong Learning | TIMSCDR Mumbai",
    description: "Explore DLLE activities at TIMSCDR Mumbai, promoting community service, social awareness, lifelong learning, and student engagement beyond the classroom.",
  },
  "/life/green-club": {
    title: "Green Club | Eco Initiatives | TIMSCDR Mumbai",
    description: "Explore the Green Club at TIMSCDR Mumbai, promoting environmental sustainability, eco-friendly practices, green campus initiatives, and student awareness.",
  },
  "/life/coding-club": {
    title: "Coding Club | TIMSCDR Mumbai MCA Institute",
    description: "Join the Coding Club at TIMSCDR Mumbai, where MCA students enhance programming skills, solve challenges, build projects, and prepare for tech careers.",
  },
  "/csi-timscdr": {
    title: "CSI TIMSCDR | Computer Society of India | Mumbai",
    description: "Explore CSI TIMSCDR, the Computer Society of India student chapter at TIMSCDR Mumbai, promoting technical knowledge, networking, and professional development.",
  },
  "/ieee-timscdr": {
    title: "IEEE TIMSCDR | Student Branch | Mumbai",
    description: "Explore the IEEE Student Branch at TIMSCDR Mumbai, connecting MCA students with global technology communities, research, and professional development opportunities.",
  },
  "/life/selfdefence": {
    title: "Self Defence Program for Women | TIMSCDR Mumbai",
    description: "Explore the self-defence programme at TIMSCDR Mumbai, empowering women students with safety skills, confidence, and awareness through expert-led training sessions.",
  },
  "/life/womenentepreneurs": {
    title: "Women Entrepreneurs Cell | TIMSCDR Mumbai",
    description: "Explore the Women Entrepreneurs Cell at TIMSCDR Mumbai, fostering entrepreneurship, leadership, innovation, and business skills among women MCA students.",
  },
  "/life/womenhealth": {
    title: "Women Health Initiatives | TIMSCDR Mumbai",
    description: "Explore women health initiatives at TIMSCDR Mumbai, promoting wellness, hygiene awareness, mental health, and overall well-being among women students.",
  },
  "/d-link-academy-lab": {
    title: "D-Link Academy Lab | Networking Lab | TIMSCDR Mumbai",
    description: "Explore the D-Link Academy Networking Lab at TIMSCDR Mumbai, providing hands-on training in networking, cybersecurity, and IT infrastructure for MCA students.",
  },
  "/life/bharatabhiyan": {
    title: "Unnat Bharat Abhiyan | TIMSCDR Mumbai",
    description: "Explore the Unnat Bharat Abhiyan initiative at TIMSCDR Mumbai, connecting students with rural communities for sustainable development and social impact.",
  },
  "/life/magazine-eminence": {
    title: "Magazine Eminence | TIMSCDR Mumbai",
    description: "Read Eminence, the student magazine of TIMSCDR Mumbai, featuring articles, research, achievements, campus news, and creative contributions from MCA students.",
  },
  "/life/newsletter": {
    title: "Newsletter | TIMSCDR Mumbai MCA Institute",
    description: "Stay updated with the TIMSCDR Newsletter featuring the latest campus news, academic updates, student achievements, events, and institutional highlights.",
  },
  "/life/yuvostav": {
    title: "Yuvostav | Cultural Fest | TIMSCDR Mumbai",
    description: "Celebrate Yuvostav, the annual cultural festival at TIMSCDR Mumbai, showcasing student talent, creativity, performances, and vibrant campus life.",
  },
  "/life/culturalday": {
    title: "Cultural Day | Student Life at TIMSCDR Mumbai",
    description: "Celebrate Cultural Day at TIMSCDR Mumbai, where MCA students showcase talent, creativity, and cultural diversity through performances, events, and activities.",
  },
  "/life/fresher-farewell": {
    title: "Freshers Welcome & Farewell | TIMSCDR Mumbai",
    description: "Experience the Freshers Welcome and Farewell celebrations at TIMSCDR Mumbai, fostering student bonding, memories, and a vibrant campus culture.",
  },
  "/life/sportsday": {
    title: "Sports Day | Student Activities at TIMSCDR Mumbai",
    description: "Explore Sports Day at TIMSCDR Mumbai, promoting fitness, teamwork, sportsmanship, and healthy competition among MCA students through various sporting events.",
  },

  // Programs - additional
  "/phd-admission": {
    title: "Ph.D. Admission | TIMSCDR Mumbai",
    description: "Apply for Ph.D. admission at TIMSCDR Mumbai in Computer Applications. Explore eligibility, research areas, faculty guides, and the admission process.",
  },

  // Life - additional
  "/parent-interaction-programme": {
    title: "Parent Interaction Programme | TIMSCDR Mumbai",
    description: "Explore the Parent Interaction Programme at TIMSCDR Mumbai, strengthening the bond between parents, students, and faculty for holistic student development.",
  },
  "/guest-lecture-sdp-pre-placement-training": {
    title: "Guest Lectures & Pre-Placement Training | TIMSCDR Mumbai",
    description: "Explore guest lectures and pre-placement training at TIMSCDR Mumbai, preparing MCA students for industry with expert sessions, skill development, and career guidance.",
  },
  "/student-development-program": {
    title: "Student Development Program | TIMSCDR Mumbai",
    description: "Explore the Student Development Program at TIMSCDR Mumbai, enhancing soft skills, technical abilities, leadership, and career readiness for MCA students.",
  },
  "/pre-placement-training": {
    title: "Pre-Placement Training | TIMSCDR Mumbai MCA Institute",
    description: "Prepare for campus placements with TIMSCDR's Pre-Placement Training, covering aptitude, coding, communication, resume building, and interview skills.",
  },

  // Remaining missing routes
  "/admission-information-private-mca-college-in-mumbai": {
    title: "MCA Admission | Best MCA College in Mumbai | TIMSCDR",
    description: "Apply to one of the Top MCA Colleges in Mumbai at Thakur Institute of Management Studies, Career Development & Research and build a successful IT career.",
  },
  "/fees-structure": {
    title: "Fees Structure | MCA College in Mumbai | TIMSCDR",
    description: "View the complete fees structure at TIMSCDR Mumbai for MCA, Integrated MCA, and MCA for Working Professionals programmes including all applicable charges.",
  },
  "/employees-handbook": {
    title: "Employees Handbook | TIMSCDR Mumbai",
    description: "Access the TIMSCDR Employees Handbook covering HR policies, service rules, conduct guidelines, and administrative procedures for faculty and staff.",
  },
  "/Working-professional-fra": {
    title: "MCA Working Professional FRA Fee Structure | TIMSCDR",
    description: "View the FRA-approved fee structure for the MCA Working Professionals programme at TIMSCDR Mumbai, including tuition and other applicable fees.",
  },
  "/11854-2": {
    title: "Ph.D. in Computer Applications in Mumbai | TIMSCDR",
    description: "Explore Ph.D. admission in Computer Applications at TIMSCDR, Mumbai. Discover eligibility, research areas and opportunities for advanced academic research.",
  },
  "/about/nisp-policy": {
    title: "NISP Policy | TIMSCDR Mumbai MCA Institute",
    description: "Read the National Innovation and Startup Policy (NISP) at TIMSCDR Mumbai, promoting entrepreneurship, innovation, and startup culture among students and faculty.",
  },
  "/contact/aicte-faculty": {
    title: "AICTE Faculty Details | TIMSCDR Mumbai",
    description: "View AICTE-approved faculty details at TIMSCDR Mumbai, including qualifications, experience, and academic credentials of teaching staff.",
  },
  "/contact/uom": {
    title: "University of Mumbai Affiliation | TIMSCDR Mumbai",
    description: "Explore TIMSCDR's affiliation with the University of Mumbai, covering academic programmes, approvals, and institutional recognition details.",
  },
  "/contact/uom-qualification": {
    title: "UoM Qualification Details | TIMSCDR Mumbai",
    description: "View University of Mumbai qualification and eligibility details for MCA and other programmes offered at TIMSCDR Mumbai.",
  },
  "/doctor-booklet": {
    title: "Doctor's Booklet | TIMSCDR Mumbai",
    description: "Access the Doctor's Booklet at TIMSCDR Mumbai providing health and medical guidance resources for students and staff on campus.",
  },
  "/Class-Improvement-MCA": {
    title: "Class Improvement MCA | TIMSCDR Mumbai",
    description: "Explore the Class Improvement scheme for MCA students at TIMSCDR Mumbai, allowing eligible students to improve their academic performance and grades.",
  },
  "/admission-procedure-2": {
    title: "Admission Procedure | MCA College in Mumbai | TIMSCDR",
    description: "Learn about the admission procedure at TIMSCDR Mumbai for MCA, Integrated MCA, and MCA for Working Professionals programmes, including eligibility and steps.",
  },
};

function normalizePath(pathname) {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "");
}

function RouteSeo() {
  const location = useLocation();
  const path = normalizePath(location.pathname);
  const metadata = routeMetadata[path];

  if (!metadata) return null;

  const canonicalUrl = `${siteUrl}${path === "/" ? "" : path}/`;

  // Directly update document head — works reliably with React 19
  document.title = metadata.title;

  let descTag = document.querySelector('meta[name="description"]');
  if (!descTag) {
    descTag = document.createElement("meta");
    descTag.setAttribute("name", "description");
    document.head.appendChild(descTag);
  }
  descTag.setAttribute("content", metadata.description);

  let canonicalTag = document.querySelector('link[rel="canonical"]');
  if (!canonicalTag) {
    canonicalTag = document.createElement("link");
    canonicalTag.setAttribute("rel", "canonical");
    document.head.appendChild(canonicalTag);
  }
  canonicalTag.setAttribute("href", canonicalUrl);

  let ogTitle = document.querySelector('meta[property="og:title"]');
  if (!ogTitle) {
    ogTitle = document.createElement("meta");
    ogTitle.setAttribute("property", "og:title");
    document.head.appendChild(ogTitle);
  }
  ogTitle.setAttribute("content", metadata.title);

  let ogDesc = document.querySelector('meta[property="og:description"]');
  if (!ogDesc) {
    ogDesc = document.createElement("meta");
    ogDesc.setAttribute("property", "og:description");
    document.head.appendChild(ogDesc);
  }
  ogDesc.setAttribute("content", metadata.description);

  return null;
}

export { routeMetadata };
export default RouteSeo;
